import styled from "styled-components";

export const StyledStarFeedback = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2px;
  align-items: center;
  justify-content: center;
`;
